import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createFormField, createForm, formShape } from 'rc-form'
import { Form, Input, TextArea, Button } from 'antd-mobile'
import { Container, Header } from '../../components_renew/Layout'
import { handleCatch } from '../../utils'
import { requestAddressData } from '../../actions/addressAction'

const nameMap = {
  name: '收件人',
  phone: '手机号码',
  region: '所在地区',
  email: '电子邮箱',
  address: '详细地址'
}

let { PATH, API, axios, toast } = window

@withRouter
@connect(state => {return { pendingData: state.addressData['form'] }})
@createForm({
  mapPropsToFields: props => {
    let { name, phone, region, address, email } = props.pendingData
    return {
      name: createFormField({ value: name }),
      phone: createFormField({ value: phone }),
      region: createFormField({ value: region }),
      email: createFormField({ value: email }),
      address: createFormField({ value: address })
    }
  }
})
class AddressForm extends React.PureComponent {
  static propTypes = {
    form: formShape
  }

  state = {
    //  判断是新增还是编辑
    isAdd: this.props.match.path === PATH.ADDRESS.ADD
  }

  render () {
    const { getFieldProps } = this.props.form
    const { isAdd } = this.state
    console.log(getFieldProps('name', { rules: [{ required: true }] }))
    return <Container>
      <Header>{isAdd ? '新增地址' : '修改地址'}</Header>
      {/*<List>*/}
      {/*  <InputItem {...getFieldProps('name', { rules: [{ required: true }] })}>{nameMap.name}</InputItem>*/}
      {/*  <InputItem {...getFieldProps('phone', { rules: [{ required: true }] })}*/}
      {/*             type={'phone'}>{nameMap.phone}</InputItem>*/}
      {/*  /!*<InputItem type={'number'}>邮政编号</InputItem>*!/*/}
      {/*  <InputItem {...getFieldProps('region', { rules: [{ required: true }] })}>{nameMap.region}</InputItem>*/}
      {/*  <InputItem {...getFieldProps('email', { rules: [{ required: true }] })}>{nameMap.email}</InputItem>*/}
      {/*  <TextareaItem {...getFieldProps('address', { rules: [{ required: true }] })} title={nameMap.address} autoHeight*/}
      {/*                rows={2}/>*/}
      {/*</List>*/}

      <Form layout='horizontal'>
        <Form.Item label={nameMap.name}>
          <Input {...getFieldProps('name', { rules: [{ required: true }] })} />
        </Form.Item>
        <Form.Item label={nameMap.phone}>
          <Input {...getFieldProps('phone', { rules: [{ required: true }] })} type="tel" />
        </Form.Item>
        <Form.Item label={nameMap.region}>
          <Input {...getFieldProps('region', { rules: [{ required: true }] })} />
        </Form.Item>
        <Form.Item label={nameMap.email}>
          <Input {...getFieldProps('email', { rules: [{ required: true }] })} />
        </Form.Item>
        <Form.Item label={nameMap.address}>
         <TextArea {...getFieldProps('address', { rules: [{ required: true }] })} rows={3} />
        </Form.Item>
      </Form>

     <div className={'p-4'}>
       <Button block color={'primary'} onClick={this.submit}>提交</Button>
     </div>
    </Container>
  }

  submit = () => {
    const { form, history, pendingData, dispatch } = this.props
    const { isAdd } = this.state
    this.validate(form).then(values => {
      let data = {
        'flag': '1',
        'isDefault': '0',
        'postCode': '510000',
        'receivingAddress': values.address.replace(/\n/g, ' '),
        'receivingEmail': values.email,
        'receivingMobile': values.phone,
        'receivingName': values.name,
        'region': values.region
      }
      let config = { data }
      if (isAdd) {
        //  新增收货地址
        Object.assign(config, {
          method: 'put',
          url: API.Address.putAddress
        })
      } else {
        //  修改收货地址
        Object.assign(config, {
          method: 'post',
          url: API.Address.postAddress(pendingData.id)
        })
      }
      toast.show('数据提交中')
      axios.request(config).then(
        () => {
          toast.info('提交成功', 1, () => {
            dispatch(requestAddressData())
            //  延时让react去remove Toast， 否则console提示错误
            setTimeout(() => {
              history.goBack()
            }, 0)
          })
        }
      ).catch(handleCatch)
    }, reject => {
      // validate验证提示
      toast.info(reject)
    })
  }

  validate = (form) => {
    return new Promise((resolve, reject) => {
      form.validateFields((error, values) => {
        values.phone = values.phone.replace(/\s*/g, '')
        if (error) {
          let newError = []
          for (let k in error) {
            if (error.hasOwnProperty(k)) {
              newError.push(nameMap[k])
            }
          }
          reject(newError.join(',') + '不能为空')
        } else if (values.phone.length !== 11) {
          // 此处antd返回的是带空格的 20241119 antd升级后的input没空格了又，而且得处理旧数据带空格的数据...
          // console.log(values.phone)
          reject('请填写正确的手机号码')
        } else {
          //  validate finish
          resolve(values)
        }
      })
    })
  }

}

export { AddressForm }
